/* eslint-disable no-unused-vars */
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import styles from './styles.module.scss'
import React from 'react'
import managementLinks from './management_links'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

function index() {
  const { t } = useTranslation() || ((key) => key)
  const location = useLocation()
  const auth = useSelector((state) => state.auth)
  const { profile } = auth?.user || {}
  const isAdmin = profile?.role === 'admin'

  // Filter management links based on user role
  const filteredLinks = managementLinks(t)?.filter(link => {
    // Only show users and prices for standard users
    if (!isAdmin) {
      return link.path === 'users' || link.path === 'prices'
    }
    return true
  })

  return (
    <>
      <div className={styles.header_container}>
        <nav className={styles.nav_links}>
          <ul className={styles.nav_links_list}>
            {filteredLinks?.map((link) => (
              <li key={link.value} className={styles.nav_links_item}>
                {!link.disabled ? (
                  <Link
                    to={link.path}
                    className={`${styles.nav__link} ${location.pathname?.includes(link.path) ? styles.active_link : ''}`}
                  >
                    {link.value}
                  </Link>
                ) : (
                  <p className={`${styles.nav__link} ${styles.disabled}`}>{link.value}</p>
                )}
              </li>
            ))}
          </ul>
        </nav>
        <Routes>
          <Route path='*' element={<Navigate to='users' />} />
          {filteredLinks?.map((link) => (
            <Route key={link.path} path={link.path} exact element={<div className={styles.page_layout}>{link.page}</div>} />
          ))}
        </Routes>
      </div>
    </>
  )
}
export default index
